namespace('compass.demographic');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.demographic.PaymentWidget');

compass.demographic.FailedCreditCardWidget = compass.defineWidget(function PaymentWidget(options) {
    var me = this;
    var $j = jQuery;
    var d = jQuery.dom;
    var _dateParse = compass.util.parse.ISODateParser;
    var _format = compass.util.dateFormatter('medium');

    var _settings = options;
    var _currentCard = _.find(_settings.storedPayments, function(card) { return card.paymentId === parseInt(_settings.paymentId); });

    var _labels = {
        failedCard: "<%= nameOnCard.replace(/ /g, '&nbsp;') %>'s <%= cardType %>&nbsp;ending&nbsp;in&nbsp;<%= lastFour %> was&nbsp;unable&nbsp;to&nbsp;be&nbsp;processed on <%= processedAt.replace(/ /g, '&nbsp;') %>.",
        useCard: "Use card",
        cardSelected: "Card selected",
        willBeChargedToday: "will be charged today"
    };

    var _stayRecapWidget;
    var _paymentWidget;
    var _updatePaymentButton;

    var _validator = new compass.validator({
        widget: me,
        onValid: function (field, opts) {
            field.removeClass("invalid");
            
            _validation_res = _validator.validate();
            if (_validation_res.length === 0) {
                _updatePaymentButton.removeClass('disabled');
            }
        },
        onInvalid: function (field, opts) {
            field.addClass("invalid");
        }
    });

    this.render = function(widgetElem) {
        var recapContainer = d.div({className:'recapContainer'});
        
        var outstandingDeposit = _.reduce(_settings.reservations, function(memo, reservation) {
            return memo + (reservation.outstandingDeposit * reservation.numRooms);
        },0);
        
        _stayRecapWidget = new compass.hotel.StayRecapWidget(recapContainer, {
            WUID : 'stayRecapWidget_individualPersonalInfo',
            recapArray : _settings.reservations,
            meetingInfo: _settings.meetingInfo,
            hasGIN: false,
            outstandingDeposit : outstandingDeposit,
            suppressChargingStatusMessages: true
        });

        var paymentContainer = d.div({className:'paymentContainer'});

				var failedCardTemplate = _.template(_labels.failedCard);
        paymentContainer.append(
            d.div({className: 'currentPayment'}, failedCardTemplate({
                nameOnCard: _currentCard.nameOnCard,
                cardType: _currentCard.type,
                lastFour: _currentCard.lastFour,
                processedAt: _format(_dateParse(_settings.reservations[0].processedAt))
            }))
        );

        _paymentWidget = new compass.demographic.PaymentWidget(paymentContainer, {
            addressWidget: _settings.countriesAndStates,
            validator: _validator,
            creditCardTypes: _settings.paymentOptions.pay_methods,
            payMethods: _settings.paymentOptions.pay_methods,
            displayCVC: _settings.paymentOptions.store_cvc,
            currentPayment : _currentCard,
            storedPayments: _settings.storedPayments,
            minExpiration: compass.util.parse.ISODateParser(_settings.meetingInfo.ends),
            // maskCCNumber : _.contains(data.extraRequiredFields, 'maskCreditCard')
        });

        _updatePaymentButton = d.button({className: 'button'}, _labels.useCard).activate(_handleUseCardClick);

        paymentContainer.append(
            _updatePaymentButton
        );

        widgetElem.append(
            d.div({className: 'clearfix'},
                recapContainer,
                paymentContainer
            )
        );
    };

    _handleUseCardClick = function(event) {
        if(_updatePaymentButton.hasClass('disabled')) {
            return;
        }

        // Disable relevant things
        _updatePaymentButton.addClass('disabled');
        _paymentWidget.disable();

        var vh = compass.util.validationHelper(_validator);
        vh.detachHints();
        
        var errorsExist = vh.attachHints();
        if(errorsExist){
            return;
        }

        // Remove text
        _updatePaymentButton.text('');

        // Add spinner
        compass.loading.start(_updatePaymentButton);

        // Fire off update event
        var eventData = {
            callback: me.paymentUpdateSuccess,
            errorCallback: me.paymentUpdateFailed,
            originalPaymentId: _settings.paymentId,
            newPaymentInfo: _paymentWidget.grabValues()
        };
        me.trigger('FailedCreditCardWidget.updateFailedCard', eventData);
    };

    me.paymentUpdateSuccess = function(data) {
        // Remove spinner
        compass.loading.stop();

        // Update the payment drop down
        _paymentWidget.addCard(data.paymentInfo);

        // Change to success text
        _updatePaymentButton.text(_labels.cardSelected);
        _updatePaymentButton.before(d.div(_labels.willBeChargedToday));
    };

    me.paymentUpdateFailed = function() {
        // Remove spinner
        compass.loading.stop();

        // Change text back
        _updatePaymentButton.text(_labels.useCard);

        // Enable relevant things
        _updatePaymentButton.removeClass('disabled');
        _paymentWidget.enable();
    };

}, {
    WUID : 'CRAP',
    widgetName : 'FailedCreditCardWidget',
});
